export default class Utils {
  static downloadFile(data, name) {
    if(name === 'report-retail' || name === 'report-curators' || name === 'report-sales' || name === "report-legal-retail") {
      const link = document.createElement('a');
      link.href = data;
      link.setAttribute('download', `${name}.csv`);
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      const href = URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', `${name}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    }
  }

  static isArray(val) {
    return Array.isArray(val);
  }

  static isPlainObject(val) {
    if (toString.call(val) !== '[object Object]') {
      return false;
    }
    const prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
  }

  static isFunction(val) {
    return toString.call(val) === '[object Function]';
  }

  static async pollExport(fetchFn, payload, delayMs = 1000) {
    let currentPayload = { ...payload };
    while (true) {
      const res = await fetchFn(currentPayload);
      if (!res.isSuccess || res.result.is_completed) {
        return res;
      }
      currentPayload = { ...currentPayload, partial_report_uuid: res.result.partial_report_uuid };
      await new Promise((resolve) => setTimeout(resolve, delayMs));
    }
  }
}
